"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Twitter, ArrowUp, MapPin, Phone, Mail, Clock } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted/50 animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        {[{
        label: "The Archive",
        href: "/TheArchivePage"
      }, {
        label: "Daily Stories",
        href: "#"
      }, {
        label: "Travel Logs",
        href: "#"
      }, {
        label: "Reach Out",
        href: "/ReachOutPage"
      }].map((item, i) => <li key={i} data-index={i}>
            <Link to={item.href} className="text-sm text-slate-500 transition-colors duration-300 hover:text-primary">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-slate-500 transition-colors duration-300 hover:text-primary">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }];
  return <section data-section-id="264921" id="footer" className="bg-background text-foreground border-t-4 border-primary pt-20 pb-8">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 inline-block">
              <WvcLogo className="h-10 w-auto text-foreground" />
            </Link>
            <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
              The Daily Explorer is a personal log of journeys, thoughts, and discoveries. Join me as I navigate the world one story at a time.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold mb-6 tracking-tight text-foreground">Navigation</h3>
            <MenuProvider menu_id="47">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold mb-6 tracking-tight text-foreground">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-slate-500 group">
                <MapPin className="size-4 mt-0.5 shrink-0 transition-colors duration-300 group-hover:text-primary" strokeWidth={1.5} />
                <span className="transition-colors duration-300 group-hover:text-primary">
                  Based in San Francisco, California
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-500 group">
                <Phone className="size-4 shrink-0 transition-colors duration-300 group-hover:text-primary" strokeWidth={1.5} />
                <span className="transition-colors duration-300 group-hover:text-primary">
                  +1 (555) EXPLORE
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-500 group">
                <Mail className="size-4 shrink-0 transition-colors duration-300 group-hover:text-primary" strokeWidth={1.5} />
                <span className="transition-colors duration-300 group-hover:text-primary">
                  hello@dailyexplorer.blog
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-500 group pt-2">
                <Clock className="size-4 mt-0.5 shrink-0 transition-colors duration-300 group-hover:text-primary" strokeWidth={1.5} />
                <span className="transition-colors duration-300 group-hover:text-primary">
                  New Posts: Mon, Wed, Fri
                </span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold mb-6 tracking-tight text-foreground">Connect</h3>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} aria-label={social.label} className="flex size-10 items-center justify-center rounded-md border border-border bg-white text-primary transition-all duration-300 hover:border-primary hover:bg-secondary hover:shadow-md">
                    <Icon className="size-4" strokeWidth={1.5} />
                  </Link>;
            })}
            </div>
          </div>

        </div>

        <Separator className="bg-border mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            &copy; {currentYear} The Daily Explorer. All rights reserved.
          </p>
          
          <Button variant="ghost" size="sm" onClick={scrollToTop} className="text-slate-500 hover:text-primary hover:bg-transparent gap-2 text-xs uppercase tracking-widest font-default">
            Back to Top
            <ArrowUp className="size-3" strokeWidth={2} />
          </Button>
        </div>
      </div>
    </section>;
}